import { render, staticRenderFns } from "./SimpleDatePicker.vue?vue&type=template&id=65dcdd6d&scoped=true&"
import script from "./SimpleDatePicker.vue?vue&type=script&lang=js&"
export * from "./SimpleDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDatePicker.vue?vue&type=style&index=0&id=65dcdd6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dcdd6d",
  null
  
)

export default component.exports